export const productData = {
  // 🏗️ MATERIAL BANGUNAN
  1: {
    id: 1,
    name: "Pasir",
    category: "Material Bangunan",
    image: "https://placehold.co/800x600?text=Pasir",
    alt: "Pasir bangunan berkualitas tinggi",
    price: "Rp 250.000 / m³",
    features: [
      "Pasir halus dan bersih",
      "Cocok untuk plester dan adukan",
      "Tersedia dalam jumlah besar",
    ],
    description:
      "Pasir bangunan berkualitas tinggi yang cocok untuk berbagai keperluan konstruksi seperti plesteran, adukan beton, dan pondasi.",
    benefits: [
      "Kualitas terjamin",
      "Proses penyaringan bersih",
      "Pengiriman cepat ke lokasi proyek",
    ],
    technicalSpecs: [
      { name: "Kadar Lumpur", value: "< 5%" },
      { name: "Jenis", value: "Pasir Halus / Kasar" },
      { name: "Asal", value: "Gunung / Sungai" },
    ],
    testimonials: [
      {
        quote: "Pasirnya bersih dan sangat cocok untuk proyek kami.",
        author: "Mandor Proyek",
        role: "Kontraktor",
      },
    ],
    integrations: ["Proyek Rumah", "Gedung", "Jalan Raya"],
  },

  2: {
    id: 2,
    name: "Batu Krical 1/2 & 2/3 Split",
    category: "Material Bangunan",
    image: "https://placehold.co/800x600?text=Batu+Krical+Split",
    alt: "Batu split berbagai ukuran",
    price: "Rp 300.000 / m³",
    rating: 4.8,
    features: [
      "Ukuran 1/2 dan 2/3 tersedia",
      "Kuat dan tahan lama",
      "Ideal untuk beton dan pondasi",
    ],
    description:
      "Batu split dengan ukuran 1/2 dan 2/3 yang cocok digunakan untuk bahan campuran beton struktural dan pondasi bangunan.",
    benefits: [
      "Kepadatan tinggi",
      "Menambah kekuatan struktur beton",
      "Tersedia pengiriman dengan dump truck",
    ],
    technicalSpecs: [
      { name: "Ukuran", value: "1/2 inch & 2/3 inch" },
      { name: "Asal", value: "Gunung lokal" },
      { name: "Kadar Air", value: "Kering" },
    ],
    testimonials: [
      {
        quote: "Kualitas batunya bagus, tidak banyak pecahan kecil.",
        author: "Insinyur Proyek",
        role: "PT Konstruksi Sejahtera",
      },
    ],
    integrations: ["Campuran Beton", "Pondasi", "Aspal"],
  },

  3: {
    id: 3,
    name: "Panel Beton",
    category: "Material Bangunan",
    image: "https://placehold.co/800x600?text=Panel+Beton",
    alt: "Panel beton pracetak",
    price: "Hubungi kami",
    rating: 4.9,
    features: [
      "Tahan cuaca ekstrem",
      "Pemasangan cepat",
      "Permukaan halus dan presisi",
    ],
    description:
      "Panel beton pracetak modern untuk dinding, pagar, dan struktur arsitektural dengan kekuatan tinggi dan tampilan profesional.",
    benefits: [
      "Menghemat waktu konstruksi",
      "Tahan lama dan minim perawatan",
      "Kualitas pabrik terstandar",
    ],
    technicalSpecs: [
      { name: "Ketebalan", value: "8 cm – 15 cm" },
      { name: "Panjang", value: "2 m – 3 m" },
      { name: "Material", value: "Beton Bertulang" },
    ],
    testimonials: [
      {
        quote: "Panelnya rapi dan kuat, hasil pemasangan presisi.",
        author: "Arsitek",
        role: "Proyek Perumahan",
      },
    ],
    integrations: ["Dinding Pagar", "Gudang", "Pabrik"],
  },

  // 🚜 ALAT BERAT
  4: {
    id: 4,
    name: "Excavator PC200",
    category: "Alat Berat",
    image: "https://placehold.co/800x600?text=Excavator+PC200",
    alt: "Excavator PC200 beroperasi di proyek",
    price: "Rp 1.200.000 / jam",
    rating: 4.9,
    features: [
      "Tenaga besar dan efisien",
      "Cocok untuk proyek skala besar",
      "Operator berpengalaman",
    ],
    description:
      "Excavator PC200 sangat cocok untuk pekerjaan gali, angkut, dan perataan tanah pada proyek besar.",
    benefits: [
      "Produktivitas tinggi",
      "Hemat bahan bakar",
      "Perawatan rutin terjamin",
    ],
    technicalSpecs: [
      { name: "Kapasitas Bucket", value: "0.8 – 1.0 m³" },
      { name: "Berat Operasi", value: "20 ton" },
    ],
  },

  5: {
    id: 5,
    name: "Excavator PC75",
    category: "Alat Berat",
    image: "https://placehold.co/800x600?text=Excavator+PC75",
    alt: "Excavator kecil PC75",
    price: "Rp 900.000 / jam",
    rating: 4.7,
    features: ["Ukuran lebih kecil", "Ideal untuk area sempit", "Performa stabil"],
    description:
      "Excavator PC75 sangat efisien untuk pekerjaan di area terbatas seperti saluran, taman, atau area perkotaan.",
    benefits: [
      "Mobilitas tinggi",
      "Hemat bahan bakar",
      "Cepat dalam pengerjaan kecil-menengah",
    ],
  },

  6: {
    id: 6,
    name: "Bull Dozer",
    category: "Alat Berat",
    image: "https://placehold.co/800x600?text=Bull+Dozer",
    alt: "Bulldozer di area tambang",
    rating: 4.8,
    features: ["Kuat dan tangguh", "Efisien meratakan tanah", "Perawatan berkala"],
    description:
      "Bulldozer digunakan untuk meratakan lahan dan memindahkan material berat di area proyek besar.",
  },

  7: {
    id: 7,
    name: "Loader",
    category: "Alat Berat",
    image: "https://placehold.co/800x600?text=Loader",
    alt: "Loader mengangkut material",
    price: "Rp 1.100.000 / jam",
    rating: 4.6,
    features: ["Bucket besar", "Cepat dalam pemuatan", "Konsumsi BBM efisien"],
    description:
      "Loader ideal untuk memindahkan material seperti pasir, batu, atau tanah dalam jumlah besar.",
  },

  8: {
    id: 8,
    name: "Vibro",
    category: "Alat Berat",
    image: "https://placehold.co/800x600?text=Vibro",
    alt: "Alat pemadat tanah Vibro",
    price: "Rp 800.000 / jam",
    rating: 4.5,
    features: ["Pemadatan optimal", "Cocok untuk jalan dan pondasi", "Getaran kuat"],
    description:
      "Vibro digunakan untuk pemadatan tanah agar permukaan siap untuk konstruksi jalan atau bangunan.",
  },

  9: {
    id: 9,
    name: "Truck",
    category: "Alat Berat",
    image: "https://placehold.co/800x600?text=Truck",
    alt: "Truck pengangkut material",
    price: "Rp 700.000 / rit",
    rating: 4.6,
    features: ["Kapasitas besar", "Efisien dan aman", "Sopir berpengalaman"],
    description:
      "Truck digunakan untuk mengangkut material seperti pasir, batu, dan tanah dari dan ke lokasi proyek.",
  },

  10: {
    id: 10,
    name: "Hiace",
    category: "Transportasi",
    image: "https://placehold.co/800x600?text=Hiace",
    alt: "Mobil Hiace untuk transportasi pekerja",
    price: "Rp 1.000.000 / hari",
    rating: 4.7,
    features: ["Kapasitas 10–12 orang", "AC dingin", "Kendaraan bersih dan nyaman"],
    description:
      "Hiace digunakan untuk transportasi karyawan atau tim proyek dengan kenyamanan maksimal.",
  },
};
